var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-3-container"},[_c('div',{staticClass:"lottie-wrapper"},[_c('v-lottie-player',{attrs:{"animationData":require('@/assets/images/message/message-sent.json'),"autoplay":"","loop":"","width":"100%","height":"100%"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }